import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4802Model } from '../kymw4802.model';
import { PastCrossGoodsSetList } from '../vo/past-cross-goods-set-list.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 過去クロス商品設定一覧取得サービス
 * @export GetPastCrossGoodsSetListService
 * @class GetPastCrossGoodsSetListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPastCrossGoodsSetListService extends PlessJsonResponderSub<any> {
  private model: KYMW4802Model;
  private successFunc: Function;
  private exceptionErrorFunc: Function;
  private vo: PastCrossGoodsSetList;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPastCrossGoodsSetListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo.pcode,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4802Model} model モデルクラス
   * @param {PastCrossGoodsSetList} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPastCrossGoodsSetListService
   */
  execute(model: KYMW4802Model, vo: PastCrossGoodsSetList, successFunc: Function, exceptionErrorFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.exceptionErrorFunc = exceptionErrorFunc;
    this.send('getPastCrossGoodsSetList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPastCrossGoodsSetListService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setBuyerCrossGoodsData(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetPastCrossGoodsSetListService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
